import React, {useState, useEffect, useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { Container } from '@material-ui/core';
import { Collapse } from '@material-ui/core';
import { ExpandLess } from '@material-ui/icons';
import { ExpandMore } from '@material-ui/icons';
import { Grid } from '@material-ui/core';
import { List } from '@material-ui/core';
import { ListItemText } from '@material-ui/core';
import { ListItemButton } from '@mui/material';
import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from 'swiper/react';

import { motion } from 'framer-motion'
import { Typography } from '@material-ui/core';

import { headRewrite } from '../function/headRewrite';

const useStyles = makeStyles((theme) => ({
    animate_container:{
        position: 'relative',
        marginBottom: theme.spacing(5),
    },
    bubbleContainer:{
        marginTop: theme.spacing(20),
        display: 'flex',
        justifyContent: 'center', /* 水平方向に中央揃え */
        alignItems: 'center',    /* 垂直方向に中央揃え */ 
    
    },
    button:{
        [theme.breakpoints.down('sm')]:{
            marginTop: theme.spacing(3),
            width: '90%',
            fontWeight: 'bold',
            paddingRight: theme.spacing(4),
            paddingLeft: theme.spacing(4),
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
        },
        [theme.breakpoints.up('sm')]:{
            width: '200px',
            fontWeight: 'bold',
            paddingRight: theme.spacing(4),
            paddingLeft: theme.spacing(4),
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
        },
        color:'black',
        backgroundColor:theme.palette.primary['300'],
        '&:hover':{
            backgroundColor:theme.palette.primary['400']
        }
    },
    description:{
        marginBottom: theme.spacing(3),
        whiteSpace: 'pre-line',
        fontWeight: 'bold',

    },
    grid:{
        marginTop: theme.spacing(3)
    },
    image:{
        [theme.breakpoints.down('md')]:{
            height: '200px'
        },
        [theme.breakpoints.up('md')]:{
            height: '200px'
        }
    },
    image_purchase:{
        width: '100%',
        marginTop: theme.spacing(5)
    },
    image_gallary:{
        width:'100%',
        height:"100%",
        borderRadius:'3%'
    },
    kaitori_caption:{
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        whiteSpace: 'pre-line',
        fontWeight: 'bold',
        fontSize:'18px',
        textDecoration: 'underline'
    },
    list:{
        [theme.breakpoints.down('sm')]:{
            marginRight: theme.spacing(2),
            marginLeft: theme.spacing(2)
        },
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(5)
    },
    list_item:{
        marginBottom: theme.spacing(3),
        borderBottom: 'solid 1px black',
    },
    list_text:{
        fontWeight: 'bold',
        lineHeight: '10px'
    },
    point:{
        marginTop: theme.spacing(5),
        fontWeight: 'bold'
    },
    title: {
        [theme.breakpoints.down('md')]:{
        },
        [theme.breakpoints.up('md')]:{
            fontSize: '35px',
            letterSpacing: '10px'
        },
        fontWeight: 'bold',
        whiteSpace: 'pre-line',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: 'white',
    },
    title_img:{
        width: '100%'
    },
    title_img_container:{
        position: 'relative',
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(5),
    },
    movingText:{
        position: 'absolute',
        fontSize: '30px',
        overflow: 'hidden'
    },
    movingText2:{
        position: 'absolute',
        top: 25,
        overflow: 'hidden'
    },
    movingText3:{
        position: 'absolute',
        top: 40,
        fontSize: '25px',
        overflow: 'hidden'
    },
    movingText4:{
        position: 'absolute',
        top: 60,
        fontSize: '28px',
        overflow: 'hidden'
    },
    movingTextContainer:{
        
    },
    note:{
        [theme.breakpoints.down('sm')]:{
            marginRight: theme.spacing(2),
            marginLeft: theme.spacing(2),
            marginTop: theme.spacing(5),
            marginBottom: theme.spacing(5),
            textDecoration: 'underline',
            lineHeight: '30px'
        },
        [theme.breakpoints.up('sm')]:{
            marginTop: theme.spacing(5),
            marginBottom: theme.spacing(10),
            whiteSpace: 'pre-line',
            textDecoration: 'underline'
        },
    },
    purchase:{
        fontWeight: 'bold',
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(5)
    },
    purchase_gallary:{
        [theme.breakpoints.down('sm')]:{
            display: 'none'
        },
    },
    purchase_gallary_sm_down:{
        [theme.breakpoints.up('sm')]:{
            display: 'none'
        },
    },
    purchase_text:{
        [theme.breakpoints.down('sm')]:{
            lineHeight: '8px',
        },
        [theme.breakpoints.up('sm')]:{
            lineHeight: '10px',
        },
        whiteSpace: 'pre-line',
        fontWeight: 'bold',
        marginBottom: theme.spacing(1),
    },
    purchase_price:{
        [theme.breakpoints.down('sm')]:{
            marginBottom: theme.spacing(2)
        },
        padding: theme.spacing(0.5),
        backgroundColor: 'black',
        width: '100px',
        color: 'white',
        fontWeight: 'bold',
        marginTop: theme.spacing(1)
    },
    sub_title:{
        [theme.breakpoints.down('sm')]:{
            marginTop: theme.spacing(10),
            marginBottom: theme.spacing(5)
        },
        [theme.breakpoints.up('sm')]:{
            marginTop: theme.spacing(15),
            marginBottom: theme.spacing(5)
        },
        fontWeight:'bold',
    },
    swiper:{
        width:'100%',
    },
    text:{
        [theme.breakpoints.down('sm')]:{
            lineHeight: '30px',
            backgroundColor: theme.palette.primary['300'], /* 背景色 */
            width: '100%',
            borderRadius: '5px',
            position: 'static',
            paddingTop: theme.spacing(5),
            paddingBottom: theme.spacing(5),
            paddingRight: theme.spacing(3),
            paddingLeft: theme.spacing(3),
            fontWeight: 'bold',
        },
        [theme.breakpoints.up('sm')]:{
            paddingTop: theme.spacing(5),
            paddingBottom: theme.spacing(5),
            fontWeight: 'bold',
            lineHeight: '10px',
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(3),
            position: 'static',
            whiteSpace: 'pre-line',
            backgroundColor: theme.palette.primary['300'], /* 背景色 */
            width: '100%',
            borderRadius: '5px'
        },
    }
}))

// ブランド表記を一部補正（デザインのマルキーは維持）
const frist_text = ["COMME des GARCONS COMME des GARCONS HOMME PLUS YOHJI YAMAMOTO ALEXANDER MCQUEEN BALENCIAGA BOTTER CECILIE BAHNSEN CELINE DAIRIKU DIOR DOUBLET DRIES VAN NOTEN "]

function KaitoriScreen(){
    const classes = useStyles()
    const navigate = useNavigate()
    const textRef = useRef(null)
    const [textWidth, setTextWidth] = useState()
    const [open, setOpen] = useState(false)
    const [question, setQuestion] = useState(false)
    const [question1, setQuestion1] = useState(false)
    const [question2, setQuestion2] = useState(false)
    const [question3, setQuestion3] = useState(false)
    const [question4, setQuestion4] = useState(false)

    const handleOpen = () => {
        setOpen(!open)
    }

    const handleQuestion = () => {
        setQuestion(!question)
    }
    
    const handleQuestion1 = () => {
        setQuestion1(!question1)
    }
    
    const handleQuestion2 = () => {
        setQuestion2(!question2)
    }

    const handleQuestion3 = () => {
        setQuestion3(!question3)
    }

    const handleQuestion4 = () => {
        setQuestion4(!question4)
    }

    const title = "ブランド服・ブランド品の高価買取｜全国対応・査定無料｜Enclopedia"
    const description = "査定・送料0円。宅配で完結する洋服・ブランド品の高価買取。最短即日査定・スピード振込。LINE査定も受付中。"
    const keyword = "ブランド買取, 洋服買取, 宅配買取, 高価買取, 全国対応"

    console.log(textWidth)

    headRewrite(title, description, keyword)

    //買取ページに飛ぶようにする
    //const handleKaitori = () => {
      //  navigate('/kaitori_form')
   //}
    //LINE査定ページに遷移w卯sる
    const handleLine = () => {
        navigate('/line_estimate')
    }

    useEffect(() => {
        const calculateTextWidth = () => {
            if (textRef.current) {
              setTextWidth(textRef.current.offsetWidth);
            }
          };
      
          calculateTextWidth(); // 初回の計算
      
          window.addEventListener('resize', calculateTextWidth);
      
          // コンポーネントがアンマウントされるときにイベントリスナーをクリーンアップ
          return () => {
            window.removeEventListener('resize', calculateTextWidth);
          };
    }, []);

    //他のリサイクル会社と差別化するために買取手法から変更する必要性がある
    //リサイクル会社買取の問題点
    //バイヤー各々の嗜好によるバイアスが買取額に反映されるの
    //他社の価格を参考にした場合にそれが適正価格とは限らない
    //宅配買取の場合振込が遅い
    //インターネットを使用した査定を実施、即日検品で査定を早める
    //在庫にすると経費として落とせないため
    //レンタル品として仕入れることで減価償却資産として経費に計上することができる
    //需要のあるものを優先的に買い付けたい
    //どういったブランドが高く買取できるか明確にする、年代。アイテムなど明確に伝えると直良
    return(
        <div className={classes.root}>
            <Container maxWidth={"xl"} style={{padding: 'initial', overflow: 'hidden'}}>
            <div className={classes.title_img_container}>
                    <Typography variant={"h1"} component="h1" className={classes.title} align="center">
                        {`アーカイブを、次の誰かへ。\n
                        デザイナーズ・ラグジュアリー\n
                        専門の買取`}
                    </Typography>
                    <img
                        className={classes.title_img}
                        style={{width: '100%'}}
                        src={process.env.REACT_APP_IMAGE_URL + "subscription/kaitori_top.png"}
                        alt="ブランド買取イメージ"
                        loading="lazy"
                        width="1280"
                        height="640"
                    />
                </div>
                <div style={{marginBottom: '100px', position: 'static'}}>
                    <div className={classes.animate_container}>
                        <motion.div
                        className={classes.movingTextContainer}
                        initial={{x: `-2884px`}}
                        animate={{x: `100%`}}
                        transition={{duration:30, ease:'linear', repeat: Infinity}}
                        >
                            <Typography variant={"h2"} component="h2" className={classes.movingText} ref={textRef} noWrap style={{fontWeight:'bold'}}>
                                COMME des GARCONS COMME des GARCONS HOMME PLUS YOHJI YAMAMOTO ALEXANDER MCQUEEN BALENCIAGA BOTTER CECILIE BAHNSEN CELINE DAIRIKU DIOR DOUBLET DRIES VAN NOTEN
                            </Typography>
                        </motion.div>
                        <motion.div
                        className={classes.movingTextContainer}
                        initial={{x: '100%'}}
                        animate={{x:`-1923px`}}
                        transition={{duration:25, ease:'linear', repeat: Infinity}}
                        >
                            <Typography variant={"h2"} component="h2" className={classes.movingText2} align="center" noWrap style={{fontWeight:'bold'}}>
                                {frist_text[0]}
                            </Typography>
                        </motion.div>
                        <motion.div
                        className={classes.movingTextContainer}
                        initial={{x: `-2404px`}}
                        animate={{x: `100%`}}
                        transition={{duration:20, ease:'linear', repeat: Infinity}}
                        >
                            <Typography variant={"h2"} component="h2" className={classes.movingText3} noWrap style={{fontWeight:'bold'}}>
                                COMME des GARCONS COMME des GARCONS HOMME PLUS YOHJI YAMAMOTO ALEXANDER MCQUEEN BALENCIAGA BOTTER CECILIE BAHNSEN CELINE DAIRIKU DIOR DOUBLET DRIES VAN NOTEN
                            </Typography>
                        </motion.div>
                        <motion.div
                        className={classes.movingTextContainer}
                        initial={{x: '100%'}}
                        animate={{x:`-1923px`}}
                        transition={{duration:35, ease:'linear', repeat: Infinity}}
                        >   
                            <Typography variant={"h2"} component="h2" className={classes.movingText4} align="center" noWrap style={{fontWeight:'bold'}}>
                                {frist_text[0]}
                            </Typography>
                        </motion.div>
                    </div>
                </div>
                <div className={classes.box}>
                    <div className={classes.bubbleContainer}>
                        <Typography variant={"p"} component={"p"} align="center" className={classes.text}>
                            {`新進ブランドからメゾンブランドまで幅広いアイテムを買取しております\n
                            LINE査定を無料で行なっておりますのでお気軽にお問い合わせください`}
                        </Typography>
                    </div>
                    <Grid container className={classes.grid}>
                        <Grid item xs={12} sm={6} md={6} lg={6} xl={6} align='center'>
                            <Button onClick={() => { navigate('/kaitori/takuhai') }} className={classes.button}>
                                宅配買取のご案内
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6} xl={6} align='center'>
                            <Button onClick={handleLine} className={classes.button}>
                                LINE査定
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} align='center'>
                            <Typography variant={'h2'} component="h2" align="center" className={classes.sub_title}>
                                Enclopediaお買い取りのポイント
                            </Typography>
                        </Grid>
                        <Grid item spacing={1} xs={12} sm={6} md={6} lg={6} xl={6} align='center'>
                            <Typography variant={'h3'} component="p" align="center" className={classes.point}>
                                送料、手数料が無料
                            </Typography>
                            <Typography variant={'p'} component="p" align="center" className={classes.note}>
                                {`宅配買取をお申し込みの際、配送料、査定料などのお客様負担はございません。\n
                                査定後にキャンセルした場合もお客様負担はございません。`}
                            </Typography>
                        </Grid>
                        <Grid item spacing={1} xs={12} sm={6} md={6} lg={6} xl={6} align='center'>
                            <Typography variant={'h3'} component="p" align="center" className={classes.point}>
                                査定完了後のキャンセルもOK
                            </Typography>
                            <Typography variant={'p'} component="p" align="center" className={classes.note}>
                                {`査定結果にご満足いただけない場合はキャンセル可能です。\n
                                査定額にご納得いただけた商品のみ、お買い取りが可能です。`}
                            </Typography>
                        </Grid>
                        <Grid item spacing={1} xs={12} sm={6} md={6} lg={6} xl={6} align='center'>
                            <Typography variant={'h3'} component="p" align="center" className={classes.point}>
                                事前に査定
                            </Typography>
                            <Typography variant={'p'} component={'p'} align='center' className={classes.note}>
                                {`オンラインで事前に状態評価ごとの料金を提示、事前査定で提示した額から下がることはございません。`}
                            </Typography>
                        </Grid>
                        <Grid item spacing={1} xs={12} sm={6} md={6} lg={6} xl={6} align='center'>
                            <Typography variant={'h3'} component="p" align="center" className={classes.point}>
                                スピード査定、入金
                            </Typography>
                            <Typography variant={'p'} component='p' align='center' className={classes.note}>
                                {`商品到着日より即日から査定、取引成立後土日祝日を除いて最短2日でお振り込み。`}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} align='center'>
                            <Typography variant={'h2'} component="h2" align="center" className={classes.sub_title}>
                                買い取り強化ブランド
                            </Typography>
                        </Grid>
                        <Grid item className={classes.purchase_gallary} xs={12} sm={6} md={3} lg={3} xl={3} align='center'>
                            <div style={{textAlign: 'center'}}>
                                <img className={classes.image_purchase} src={process.env.REACT_APP_IMAGE_URL + "subscription/enclopedia_purchase_1.jpg"}/>
                            </div>
                        </Grid>
                        <Grid item className={classes.purchase_gallary} xs={12} sm={6} md={3} lg={3} xl={3} align='center'>
                            <div style={{textAlign: 'center'}}>
                                <img className={classes.image_purchase} src={process.env.REACT_APP_IMAGE_URL + "subscription/enclopedia_purchase_2.png"}/>
                            </div>
                        </Grid>
                        <Grid item className={classes.purchase_gallary} xs={12} sm={6} md={3} lg={3} xl={3} align='center'>
                            <div style={{textAlign: 'center'}}>
                                <img className={classes.image_purchase} src={process.env.REACT_APP_IMAGE_URL + "subscription/enclopedia_purchase_3.png"}/>
                            </div>
                        </Grid>
                        <Grid item className={classes.purchase_gallary} xs={12} sm={6} md={3} lg={3} xl={3} align='center'>
                            <div style={{textAlign: 'center'}}>
                                <img className={classes.image_purchase} src={process.env.REACT_APP_IMAGE_URL + "subscription/enclopedia_purchase_4.png"}/>
                            </div>
                        </Grid>
                        <Grid item className={classes.purchase_gallary_sm_down} xs={12} sm={6} md={3} lg={3} xl={3} align='center'>
                            <Swiper pagination={true} modules={[Pagination]} className={classes.swiper}>
                                <SwiperSlide key={"1"}>
                                    <div style={{textAlign: 'center'}}>
                                        <img className={classes.image_gallary} src={process.env.REACT_APP_IMAGE_URL + "subscription/enclopedia_purchase_1.jpg"}/>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide key={"2"}>
                                    <div style={{textAlign: 'center'}}>
                                        <img className={classes.image_gallary} src={process.env.REACT_APP_IMAGE_URL + "subscription/enclopedia_purchase_2.png"}/>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide key={"3"}>
                                    <div style={{textAlign: 'center'}}>
                                        <img className={classes.image_gallary} src={process.env.REACT_APP_IMAGE_URL + "subscription/enclopedia_purchase_3.png"}/>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide key={"4"}>
                                    <div style={{textAlign: 'center'}}>
                                        <img className={classes.image_gallary} src={process.env.REACT_APP_IMAGE_URL + "subscription/enclopedia_purchase_4.png"}/>
                                    </div>
                                </SwiperSlide>
                            </Swiper>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} align='center'>
                            <Typography variant={'p'} component="p" align="center" className={classes.kaitori_caption}>
                                {`上記以外のYOHJI YAMAMOTO、RAF SIMONS、RICK OWENSなどのブランドも\n
                                強化買取を行っておりますのでお気軽にお問い合わせください`}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} align='center'>
                            <Typography variant={"h2"} component={"h2"} align="center" className={classes.purchase}>
                                買取実績
                            </Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={3} lg={3} xl={3} align='center'>
                            <Typography variant={"p"} component="p" align="center" className={classes.purchase_text}>
                            {`COMME DES GARCONS 
                            \nHOMME PLUS 
                            \n2022SS ジャケット`}
                            </Typography>
                            <div style={{textAlign: 'center'}}>
                                <img className={classes.image} src={process.env.REACT_APP_IMAGE_URL + "subscription/purchase_result1.png"}/>
                            </div>
                            <Typography variant={"p"} component="p" align="center" className={classes.purchase_price}>
                                買取 ¥35000
                            </Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={3} lg={3} xl={3} align='center'>
                            <Typography variant={"p"} component="p" align="center" className={classes.purchase_text}>
                                {`RAF SIMONS 
                                \n2020AW
                                \nテーラードジャケット`}
                            </Typography>
                            <div style={{textAlign: 'center'}}>
                                <img className={classes.image} src={process.env.REACT_APP_IMAGE_URL + "subscription/purchase_result2.jpg"}/>
                            </div>
                            <Typography variant={"p"} component="p" align="center" className={classes.purchase_price}>
                                買取 ¥50000
                            </Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={3} lg={3} xl={3} align='center'>
                            <Typography variant={"p"} component="p" align="center" className={classes.purchase_text}>
                                {`sacai
                                \n2023SS
                                \nドッキングコート`}
                            </Typography>
                            <div style={{textAlign: 'center'}}>
                                <img className={classes.image} src={process.env.REACT_APP_IMAGE_URL + "subscription/purchase_result3.jpg"}/>
                            </div>
                            <Typography variant={"p"} component="p" align="center" className={classes.purchase_price}>
                                買取 ¥50000
                            </Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={3} lg={3} xl={3} align='center'>
                            <Typography variant={"p"} component="p" align="center" className={classes.purchase_text}>
                                {`JUNYA WATANABE MAN
                                \n2023aw 
                                \nダウンベスト`}
                            </Typography>
                            <div style={{textAlign: 'center'}}>
                                <img className={classes.image} src={process.env.REACT_APP_IMAGE_URL + "subscription/purchase_result4.jpg"}/>
                            </div>
                            <Typography variant={"p"} component="p" align="center" className={classes.purchase_price}>
                                買取 ¥38000
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} align='center'>
                            <Typography variant={'h2'} component="h2" align="center" className={classes.sub_title}>
                                お買い取りに関するよくある質問
                            </Typography>
                            <List className={classes.list}>
                                <ListItemButton onClick={handleOpen} style={{padding: 'initial'}}>
                                    <ListItemText component="p" primary={`お買い取りできないものはありますか？`} className={classes.list_item} />
                                    { open ? <ExpandLess/> : <ExpandMore/> }
                                </ListItemButton>
                                <Collapse in={open} timeout="auto" unmountOnExit>
                                    <List className={classes.description} component="div" disablePadding>
                                        <ListItemText component="p" className={classes.list_text} primary={`当社が定めた基準によりお買い取りできないものがございます。\n
                                            偽造品・コピー品、ブランドタグ・品質タグが欠損しているもの、ファストファッションなど一部お買い取りできないものがございますのでお申し込み前にお問い合わせください。`}/>
                                    </List>
                                </Collapse>
                                <ListItemButton onClick={handleQuestion} style={{padding: 'initial'}}>
                                    <ListItemText component="p" primary="取り扱いブランドに記載がないブランドでもお買い取りは可能ですか？" className={classes.list_item}/>
                                    { question ? <ExpandLess/> : <ExpandMore/> }
                                </ListItemButton>
                                <Collapse in={question} timeout="auto" unmountOnExit>
                                    <List className={classes.description} component="div" disablePadding>
                                        <ListItemText component="p" primary={`可能でございます、記載にある取り扱いブランドはほんの一部となります。\n
                                            デザイナーズブランド、セレクトショップオリジナルブランドから、カジュアルブランドまで幅広く買取を行っております。\n
                                            ファストファッションブランドなど、一部お買い取りできないブランドもございますので、お申し込み前にご確認ください。`}/>
                                    </List>
                                </Collapse>
                                <ListItemButton onClick={handleQuestion1} style={{padding: 'initial'}}>
                                    <ListItemText component="p" primary="季節に合ったアイテムの方が高く買い取ってもらいますか？" className={classes.list_item}/>
                                    { question1 ? <ExpandLess/> : <ExpandMore/> }
                                </ListItemButton>
                                <Collapse in={question1} timeout="auto" unmountOnExit>
                                    <List className={classes.description} component="div" disablePadding>
                                    <ListItemText component="p" primary={`季節に関係なく同様の基準でお買い取り致します。\n
                                        発売された時期が新しいアイテム、トレンドアイテム、希少価値の高いブランドアーカイブアイテムなどは高く買取ができる傾向にありますので早めにご相談ください。`}/>
                                    </List>
                                </Collapse>
                                <ListItemButton onClick={handleQuestion2} style={{padding: 'initial'}}>
                                    <ListItemText component="p" primary="洋服以外のアイテムは買い取っていただけますか？" className={classes.list_item}/>
                                    { question2 ? <ExpandLess/> : <ExpandMore/> }
                                </ListItemButton>
                                <Collapse in={question2} timeout="auto" unmountOnExit>
                                    <List className={classes.description} component="div" disablePadding>
                                        <ListItemText component="p" primary="バッグ、靴、帽子、マフラー、アクセサリーなどの服飾雑貨も取り扱っています。"/>
                                    </List>
                                </Collapse>
                                <ListItemButton onClick={handleQuestion3} style={{padding: 'initial'}}>
                                    <ListItemText component="p" primary="汚れのあるものは買い取って頂けますか？" className={classes.list_item}/>
                                    { question3 ? <ExpandLess/> : <ExpandMore/> }
                                </ListItemButton>
                                <Collapse in={question3} timeout="auto" unmountOnExit>
                                    <List className={classes.description} component="div" disablePadding>
                                        <ListItemText component="p" primary={`買取対象でございます。\n
                                            S~Eまでの評価基準を設けており傷、汚れが多く状態が悪いものほどお安くなる傾向にございます。`}/>
                                    </List>
                                </Collapse>
                                <ListItemButton onClick={handleQuestion4} style={{padding: 'initial'}}>
                                    <ListItemText component="p" primary="付属品があった方が査定は高くなりますか？" className={classes.list_item}/>
                                    { question4 ? <ExpandLess/> : <ExpandMore/> }
                                </ListItemButton>
                                <Collapse in={question4} timeout="auto" unmountOnExit>
                                    <List className={classes.description} component="div" disablePadding>
                                        <ListItemText component="p" primary={`未使用状態の場合に限りプライスタグなどの付属品がある場合はA→S判定となり査定額はアップ致します。\n
                                            付属品がある場合でもアイテムの状態が悪い場合は評価基準が下がります。`}/>
                                    </List>
                                </Collapse>
                            </List>
                        </Grid>
                    </Grid>
                </div>
            </Container>
        </div>
    )
}

export default KaitoriScreen
